import { type Enum } from '@webapp/utils/enums'

export const ssoProviderOptions = {
  AZURE: 'azure-oidc',
  DUO: 'duo-oidc',
  OKTA: 'okta-oidc',
  ONELOGIN: 'onelogin-oidc',
} as const

export type SsoProviderOption = Enum<typeof ssoProviderOptions>
